import { Injectable } from '@angular/core';
import { Observable, of } from 'rxjs';
import { shareReplay, tap } from 'rxjs/operators';
import { IProductListFilter } from '../models/product.model';
import { ProductService } from './api/product.service';

@Injectable({ providedIn: 'root' })
export class ProductFilterService {
    private filterRanges?: Partial<IProductListFilter>;
    private filterRanges$?: Observable<Partial<IProductListFilter>>;

    constructor(private productService: ProductService) {}

    getFilterRanges(): Observable<Partial<IProductListFilter>> {
        if (this.filterRanges) {
            return of(this.filterRanges);
        }

        if (!this.filterRanges$) {
            this.filterRanges$ = this.productService.getProductFilterRanges().pipe(
                tap((ranges) => (this.filterRanges = ranges)),
                shareReplay(1),
            );
        }

        return this.filterRanges$;
    }
}
